import styled from 'styled-components';
import { media } from '@minerva-analytics/pantheon';
import { BLUE, BLACK, ORANGE } from 'root/theme';
import Image from 'components/Image';
import InlineSVG from 'svg-inline-react';


const SVGImage = styled(InlineSVG)`
  margin-right: 25px;
  svg {
    width: 40px;
    g path {
      fill: ${BLUE};
      stroke: ${BLUE};
    }
    g rect {
      fill: ${BLUE};
      stroke: ${BLUE};
    }
  }
`;

const StyledImage = styled(Image)`
  width: 60px;
  height: 60px;
`;

const JoinQuizhiveText = styled.h3`
  color: ${ORANGE};
  font-weight: 600;
  font-size: 24px;
  margin: 30px 0px 20px;
`;

const TextAndSVG = styled.div`
  width: 100%;
  margin-bottom: 10px;
  display: inline-flex;
  align-items: center;
  font-size: 16px;
  text-align: left;
  color: ${BLACK};
`;

const Container = styled.div`
  background: white;
  text-align: center;
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Headline = styled.h2`
  color: ${BLUE};
  font-weight: 600;
  font-size: 24px;
  margin: 0;
  padding: 0 3rem;
  margin-bottom: 20px;
  ${media.small`
    padding: 0;
    margin-bottom: 0;
    font-size: 1.5rem;
  `}
`;

const EasyFree = styled.p`
  color: ${BLACK};
`;
const OptInText = styled.div`
  color: ${BLACK};
  padding-top: 1rem;
  font-size: 13px;
`;

const IconTextListWrapper = styled.div`
  width: 100%;
  max-width: 300px;
`;

export {
  Container,
  Headline,
  EasyFree,
  OptInText,
  TextAndSVG,
  JoinQuizhiveText,
  StyledImage,
  SVGImage,
  IconTextListWrapper,
};
